import React from 'react';
import styled from 'styled-components';
import Filter from '../../assets/icons/Filter';

interface FilterIconWithBadgeProps {
  filtered: boolean;
  filterCount: number;
}

const FilterIconWithBadge: React.FC<FilterIconWithBadgeProps> = ({
  filtered,
  filterCount,
}) => {
  return (
    <FilterIconContainer>
      <Filter 
        style={{
          cursor: 'pointer',
          color: filtered || filterCount > 0 ? '#1890ff' : undefined
        }} 
      />
      {filterCount > 0 && (
        <FilterBadge>
          {filterCount}
        </FilterBadge>
      )}
    </FilterIconContainer>
  );
};

const FilterIconContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const FilterBadge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  background: #1A1A1A;
  color: white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  min-width: 16px;
`;

export default FilterIconWithBadge;
